<template>
  <section class="has-text-centered column">
    <card-component title="No cuenta con beneficios" icon="account-remove">
      <p>
        Registra al cliente <strong>{{ document }}</strong> para que pueda
        acceder al beneficio
      </p>
      <hr />
      <div class="is-flex is-justify-content-center">
        <b-button class="is-dark ml-2" @click.native="goBack">
          Volver al inicio
        </b-button>
        <b-button class="is-primary ml-2" @click.native="registerSegment">
          Registrar segmento
        </b-button>
      </div>
    </card-component>
  </section>
</template>

<script>
import CardComponent from "@/components/CardComponent";
import ValidateService from "@/services/ValidateService";
export default {
  components: {
    CardComponent,
  },
  data() {
    return {
      local: this.$localStorage.get("local"),
    };
  },
  props: {
    document: String,
    company_provider: Number,
  },
  methods: {
    goBack() {
      this.$emit("goBack", 0);
    },
    async registerSegment() {
      this.isLoading = true;
      try {
        await ValidateService.putRegisterSegment({
          num_document: this.document,
          company_provider: this.company_provider,
          local_id: this.local,
        });
        this.$emit("goBack", 4);
      } catch (error) {
        this.$store.commit("settings/SET_ALERT", {
          isAlert: true,
          alertType: "danger",
          alertMessage: "Error al registrar el segmento",
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
